import { motion } from "framer-motion";
const animationConfiguration = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	exit: { opacity: 0 },
};

const curtainVariant = {
	enter: {
	  transition: {
		staggerChildren: 0.08
	  }
	},
	end: {
	  transition: {
		staggerChildren: 0.05,
		staggerDirection: -1
	  }
	}
  }
  
  const colorVariant = {
	start: { scaleY: 1 },
	enter: {
	  scaleY: 0,
	  transition: {
		duration: 0.8,
		ease: "easeInOut"
	  }
	},
	end: {
	  scaleY: 1,
	  transition: {
		duration: 0.5,
		ease: "easeInOut"
	  }
	}
  }

const Transitions = ({ children }) => {
	return (<>

	{/* curtain transtion */}
		<motion.div  
        initial="start"
        animate="enter"
        exit="end"
        variants={curtainVariant}
        className="curtain">	
  <motion.div variants={colorVariant} className="color-1">
	
	
	</motion.div> 
        <motion.div variants={colorVariant} className="color-2" />
        <motion.div variants={colorVariant} className="color-3" />
		</motion.div>

{/* fade transtion */}
		<motion.div
			variants={animationConfiguration}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={{ duration: 0.5  }}
			
		>
			{children}
		</motion.div>
		</>
	);
};
export default Transitions;
